'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Group = function Group(_ref) {
  var children = _ref.children,
      selection = _ref.selection,
      stretch = _ref.stretch,
      inline = _ref.inline;

  var GroupClassNames = selection ? (0, _classnames2.default)('luna-form__selectionGroup', {
    'luna-form__selectionGroup--inline': inline,
    'luna-form__selectionGroup--stretch': stretch
  }) : 'luna-form__group';
  return _react2.default.createElement(
    'div',
    { className: GroupClassNames },
    children
  );
};

Group.propTypes = {
  selection: _propTypes2.default.bool,
  stretch: _propTypes2.default.bool,
  inline: _propTypes2.default.bool
};

exports.default = Group;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Group/Group.js